module.exports = __webpack_public_path__ + "static/img/Yiadd.cffff02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Yiadd.png
// module id = et8p
// module chunks = 0